"use strict";
module.exports = {
    moneyFormatOptions: {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL"
    },
    niveisUsuario: [
        "Administrador", "Coordenador", "Consultor", "Cliente"
    ],
    niveisPerfil: [
        {
            name: "Administrador",
            value: "ADMIN"
        }, {
            name: "Admin. SUSEP",
            value: "ADMIN_SUSEP"
        }, {
            name: "Corretor",
            value: "CORRETOR"
        }
    ],
    notificationPopupLimit: 3,
    mocks: {
        timeline: {
            proposta: {
                time: "2018-01-15",
                status: "OK",
                deadline: "2018-01-15"
            },
            credito: {
                time: "2018-01-18",
                status: "OK",
                deadline: "2018-01-18"
            },
            subscricao: {
                time: "2018-01-20",
                status: "OK",
                deadline: "2018-01-20"
            },
            reseguro: {
                time: "2018-01-22",
                status: "LATE",
                deadline: "2018-01-20"
            },
            emissao: {
                time: "2018-01-22",
                status: "LATE",
                deadline: "2018-01-20"
            },
            previsao: null
        },
        ccg: {
            representantes_legais: [
                {
                    id_pessoa: 12,
                    nome: "Rivelino",
                    documento: "80483724017",
                    email: "rivelino@email.com"
                }
            ],
            fiadores: [
                {
                    id_pessoa: 35,
                    nome: "Raphael",
                    documento: "12343212343",
                    tipo_pessoa: "FISICA",
                    email: "raphael@email.com",
                    conjuge: {
                        id_pessoa: 36,
                        nome: "Raphaela",
                        documento: "43223443223",
                        email: "raphaela@email.com",
                        tipo_pessoa: "FISICA"
                    }
                }, {
                    id_pessoa: 37,
                    nome: "Hololens LTDA",
                    documento: "12123234000123",
                    tipo_pessoa: "JURIDICA",
                    representantes: [
                        {
                            id_pessoa: 38,
                            nome: "Diego",
                            documento: "54354334554",
                            tipo_pessoa: "FISICA",
                            email: "diego@email.com",
                            conjuge: {
                                id_pessoa: 39,
                                nome: "Daiane",
                                documento: "12398723487",
                                email: "daiane@email.com",
                                tipo_pessoa: "FISICA"
                            }
                        }, {
                            id_pessoa: 40,
                            nome: "Gustavo",
                            documento: "98778998787",
                            tipo_pessoa: "FISICA",
                            email: "gustavo@email.com",
                            conjuge: null
                        }
                    ]
                }
            ]
        }
    },
    bancos: [
        {
            id: "000",
            text: "000 - VISA"
        },
        {
            id: "001",
            text: "001 - Banco do Brasil"
        },
        {
            id: "004",
            text: "004 - B Nordeste do Brasil"
        },
        {
            id: "008",
            text: "008 - MERIDIONAL"
        }, {
            id: "021",
            text: "021 - ESTADO ESPIR. SANTO"
        }, {
            id: "027",
            text: "027 - ESTADO S. CATARINA"
        }, {
            id: "029",
            text: "029 - BANERJ"
        }, {
            id: "033",
            text: "033 - Banco Santander (Brasil) S.A."
        }, {
            id: "038",
            text: "038 - ESTADO DO PARANA"
        }, {
            id: "041",
            text: "041 - EST. RIO G. DO SUL"
        }, {
            id: "048",
            text: "048 - BEMGE S/A"
        }, {
            id: "070",
            text: "070 - BRASILIA S/A"
        }, {
            id: "077",
            text: "077 - Banco Inter"
        }, {
            id: "085",
            text: "085 - CREDCREA"
        }, {
            id: "104",
            text: "104 - CAIXA ECON. FEDERAL"
        }, {
            id: "219",
            text: "219 - ZOGBI S/A"
        }, {
            id: "231",
            text: "231 - BOAVISTA INTERATLA."
        }, {
            id: "237",
            text: "237 - Bradesco"
        }, {
            id: "244",
            text: "244 - BANCO CIDADE"
        }, {
            id: "254",
            text: "254 - PARANÁ BANCO"
        }, {
            id: "275",
            text: "275 - REAL"
        }, {
            id: "291",
            text: "291 - BCN"
        }, {
            id: "320",
            text: "320 - IND. E COM. S. PAULO"
        }, {
            id: "341",
            text: "341 - Banco Itaú S.A."
        }, {
            id: "346",
            text: "346 - INDEFINIDO"
        }, {
            id: "347",
            text: "347 - SUDAMERIS"
        }, {
            id: "356",
            text: "356 - REAL 356"
        }, {
            id: "389",
            text: "389 - MERCANTIL"
        }, {
            id: "392",
            text: "392 - MERCANTIL-FINASA"
        }, {
            id: "399",
            text: "399 - HSBC"
        }, {
            id: "409",
            text: "409 - UNIBANCO"
        }, {
            id: "422",
            text: "422 - SAFRA"
        }, {
            id: "424",
            text: "424 - SANTANDER NOROESTE"
        }, {
            id: "453",
            text: "453 - RURAL"
        }, {
            id: "479",
            text: "479 - BANKBOSTON"
        }, {
            id: "641",
            text: "641 - BBV BANCO"
        }, {
            id: "702",
            text: "702 - BANCO SANTOS"
        }, {
            id: "745",
            text: "745 - CITIBANK"
        }, {
            id: "748",
            text: "748 - SICREDI"
        }, {
            id: "756",
            text: "756 - Sicoob"
        }, {
            id: "999",
            text: "999 - NENHUM"
        }
    ],
    moneyConfig: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false
    },
    estados: [
        {
            nome: "Acre",
            value: "AC"
        },
        {
            nome: "Alagoas",
            value: "AL"
        },
        {
            nome: "Amapá",
            value: "AP"
        },
        {
            nome: "Amazonas",
            value: "AM"
        }, {
            nome: "Bahia",
            value: "BA"
        }, {
            nome: "Ceará",
            value: "CE"
        }, {
            nome: "Distrito Federal",
            value: "DF"
        }, {
            nome: "Espírito Santo",
            value: "ES"
        }, {
            nome: "Goiás",
            value: "GO"
        }, {
            nome: "Maranhão",
            value: "MA"
        }, {
            nome: "Mato Grosso",
            value: "MT"
        }, {
            nome: "Mato Grosso do Sul",
            value: "MS"
        }, {
            nome: "Minas Gerais",
            value: "MG"
        }, {
            nome: "Pará",
            value: "PA"
        }, {
            nome: "Paraíba ",
            value: "PB"
        }, {
            nome: "Paraná",
            value: "PR"
        }, {
            nome: "Pernambuco",
            value: "PE"
        }, {
            nome: "Piauí",
            value: "PI"
        }, {
            nome: "Rio de Janeiro",
            value: "RJ"
        }, {
            nome: "Rio Grande do Norte",
            value: "RN"
        }, {
            nome: "Rio Grande do Sul ",
            value: "RS"
        }, {
            nome: "Rondônia",
            value: "RO"
        }, {
            nome: "Roraima",
            value: "RR"
        }, {
            nome: "Santa Catarina ",
            value: "SC"
        }, {
            nome: "São Paulo ",
            value: "SP"
        }, {
            nome: "Sergipe",
            value: "SE"
        }, {
            nome: "Tocantins",
            value: "TO"
        }
    ],

    paises: [
        "Brasil",
        "Brasil",
        "Alemanha",
        "Angola",
        "Austrália",
        "Áustria",
        "Bélgica",
        "Bulgária",
        "Camarões",
        "Canadá",
        "Chipre",
        "Dinamarca",
        "Emirados Árabes Unidos",
        "Eslováquia",
        "Eslovénia",
        "Espanha",
        "Estados Unidos da América",
        "Estónia",
        "Finlândia",
        "França",
        "Grécia",
        "Holanda",
        "Hungria",
        "Irlanda",
        "Islândia",
        "Itália",
        "Letónia",
        "Lituânia",
        "Luxemburgo",
        "Malta",
        "Moçambique",
        "Noruega",
        "Polónia",
        "Qatar",
        "Reino Unido da Grã-Bretanha e Irlanda do Norte",
        "República Checa",
        "Roménia",
        "Suécia",
        "Suíça",
        "Turquia"
    ]

};



// WEBPACK FOOTER //
// ./src/app.settings.js